import React from 'react';
import styled from 'styled-components';
import { IoDocumentTextOutline } from 'react-icons/io5';

const StyledIoDocumentTextOutline = styled(({ className }) => (
  <IoDocumentTextOutline className={className} />
))`
    font-size: 16px;
    margin: auto 8px auto auto;
`;

export default StyledIoDocumentTextOutline;
